export const version = "hdnode/5.7.0";
//# sourceMappingURL=_version.js.map